const state = {
    user: null,
    chips:null,
    token: null,
    eventDetailHideSections: [],
    mybetsTabActive:false,
    lock_settings:null,
    bonusAvailable:null,
    isOffer: true
};
const getters = {
    isAuthenticated: state => !!state?.user,    
    stateUser: state => state?.user,
    chips: state => state?.chips,
    token: state => state?.token,
    eventDetailHideSections: state => state?.eventDetailHideSections,
    mybetsTabActive: state => state?.mybetsTabActive,
    lock_settings: state => state?.lock_settings,
    bonusAvailable: state => state?.bonusAvailable,
    isOffer: state => state?.isOffer,
};
const actions = {
    setUser ({ commit},user) {
        commit('setUser',user);
    },
    setChips({ commit }, chips) {
        commit('setChips', chips);
    },

    setToken({ commit }, token) {
        commit('setToken', token);
    },
    seteventDetailHideSections({ commit }, filter) {
        commit('seteventDetailHideSections', filter);
    },
    setMybetsTabActive({ commit }, mybetsTabActive) {
        commit('setMybetsTabActive', mybetsTabActive);
    },
    setEventManage({ commit }, token) {
        commit('setEventManage', token);
    },
    setBonusAvailable({ commit }, token) {
        commit('setBonusAvailable', token);
    },
    setIsOffer({ commit }, isOffer) {
        commit('setIsOffer', isOffer);
    },
};
const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setChips(state, chips) {
        state.chips = chips
    },
    setToken(state, token) {
        state.token = token;
    },
    seteventDetailHideSections(state, eventDetailHideSections) {
        state.eventDetailHideSections = eventDetailHideSections;
    },
    setMybetsTabActive(state, mybetsTabActive) {
        state.mybetsTabActive = mybetsTabActive;
    },
    setEventManage(state, lock_settings) {
        state.lock_settings = lock_settings;
    },
    setBonusAvailable(state, bonusAvailable) {
        state.bonusAvailable = bonusAvailable;
    },
    setIsOffer(state, isOffer) {
        state.isOffer = isOffer;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};